import { jsxs as _jsxs } from "react/jsx-runtime";
import { useComponents, } from "@react-fluent-edit/core";
import { useMentionPlugin } from "../utils";
const MentionElement = ({ attributes, children, element, }) => {
    const plugin = useMentionPlugin();
    const { chipComponent: Chip } = useComponents();
    const Comp = (plugin === null || plugin === void 0 ? void 0 : plugin.options.chipComponent) || Chip;
    return (_jsxs(Comp, Object.assign({ style: element.style, attributes: attributes, "data-testid": `mention-${element.value.replace(" ", "-")}` }, { children: [element.trigger, element.value, children] })));
};
export default MentionElement;
